import React from 'react';

const ValuesSection: React.FC = () => {
  const values = [
    {
      icon: 'ri-star-line',
      title: 'Quality First',
      description: 'We partner with trusted manufacturers to ensure every piece of furniture meets our high standards for durability and design.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Best Prices',
      description: 'Our strong supplier relationships and efficient operations allow us to offer the most competitive pricing in South Carolina.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Exceptional Service',
      description: 'From initial consultation to final installation, we provide personalized attention and support throughout your project.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Local Expertise',
      description: 'Deep understanding of South Carolina business culture and needs, with local teams who care about your success.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Reliability',
      description: 'Consistent delivery, professional installation, and ongoing support you can count on for all your office furniture needs.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'Staying current with the latest trends in office design and ergonomic solutions to enhance workplace productivity.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our <strong>Core Values</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            These principles guide everything we do and define our commitment to excellence in office furniture solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="text-center p-6">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${value.icon} text-3xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;